import React from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import TopSection from "../components/TopSection/FirstPageTopSection";
import InfoBox from "../components/InfoBox/FirstPageInfoBox";
import { StoreService } from "../services/store-service";
import DefaultLogo from "../assets/images/logo.png";
import styles from "./HelpPage.module.css"; 

const HelpPage: React.FC = () => {
  const navigate = useNavigate();

  const businessProfile = StoreService.GetData("business-profile");

  const logoSrc = businessProfile?.logo || DefaultLogo;
  const title = businessProfile?.name || "سالن زیبایی مینا راد";
  const subtitle = businessProfile?.slogan || "لاین زیبایی";

  const steps = [
    "1. در نوار پایین دکمه Share را انتخاب کنید.",
    "2. در منوی باز شده، گزینه Add to home screen را انتخاب کنید.",
    "3. در مرحله بعد، گزینه Add را انتخاب کنید.",
  ];

  return (
    
      <div className={styles.helpPageContainer}>
        <TopSection logoSrc={logoSrc} title={title} subtitle={subtitle} />
        
        <div className={styles.container}>
          <p className={styles.description}>
            وب اپلیکیشن {title} را به صفحه اصلی گوشی‌تان اضافه کنید
          </p>
        </div>
  
        <InfoBox
          steps={steps}
          buttonText="متوجه شدم"
          onButtonClick={() => navigate("/mobile-verify")}
        />
      </div>
 
  );
  
};

export default HelpPage;
